import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../DataStore/AuthContext';

const StarterPanel = ({greetingText = 'Welcome'}) => {
  const [currentTime, setCurrentTime] = useState(new Date());
  const {user, getMyProfile, connectedProfiles: activeProfile} = useAuth();
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  useEffect(()=>{
    getMyProfile();
  }, []);


  const formatDateTime = (date) => {
    const options = {
      weekday: 'short', year: 'numeric', month: 'short', day: 'numeric',
      hour: '2-digit', minute: '2-digit', hour12: true,
    };
    return date.toLocaleString('en-US', options);
  };

  
  return (
    <div className="col-lg-4 mb-4 pr-4 starter-panel">
      <h1 className="display-5 mb-1">
        <span className='thin-text'>{greetingText}</span> <span className="text-success thin-text">{user?.first_name}!</span>
      </h1>
      <p className="lead mb-0 text-12">{activeProfile?.org_name}</p>
      <p className="text-muted">{formatDateTime(currentTime)}</p>

    </div>
  );
};

export default StarterPanel;
